
export interface SEOData {
  title: string;
  description: string;
  keywords: string[];
  ogImage?: string;
  structuredData?: any;
}

export const defaultSEO: SEOData = {
  title: 'JUV Medspa™ - Premium Aesthetic Treatments & Wellness',
  description: 'Experience luxury aesthetic treatments including Botox, fillers, facials, and more at JUV Medspa™. Professional care with memberships and same-day appointments.',
  keywords: ['medspa', 'botox', 'fillers', 'facial treatments', 'aesthetic medicine', 'wellness', 'beauty treatments', 'medical spa'],
  ogImage: '/og-image.jpg'
};

export const pageSEOData: Record<string, SEOData> = {
  '/': {
    title: 'JUV Medspa™ - Feel Good in Your Skin Every Day',
    description: 'Botox, fillers, facials, and more — all under one roof. At JUV, we make it easy to glow on your terms with memberships, same-day treatments, and real results.',
    keywords: ['medspa', 'botox', 'dermal fillers', 'facial treatments', 'aesthetic medicine', 'beauty treatments', 'medical spa', 'wellness'],
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'MedicalBusiness',
      'name': 'JUV Medspa™',
      'description': 'Premium aesthetic treatments and wellness services',
      'url': 'https://juvmedspa.com',
      'telephone': '+1-555-JUV-GLOW',
      'priceRange': '$$',
      'medicalSpecialty': 'Aesthetic Medicine'
    }
  },
  '/treatments': {
    title: 'Premium Aesthetic Treatments | JUV Medspa™',
    description: 'Discover our comprehensive range of aesthetic treatments including Botox, dermal fillers, HydraFacials, laser treatments, and more. Expert care with immediate results.',
    keywords: ['botox treatments', 'dermal fillers', 'hydrafacial', 'laser treatments', 'aesthetic procedures', 'anti-aging', 'skin rejuvenation'],
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      'serviceType': 'Aesthetic Medical Treatments',
      'provider': {
        '@type': 'MedicalBusiness',
        'name': 'JUV Medspa™'
      }
    }
  },
  '/membership': {
    title: 'JUV Membership Plans - Exclusive Benefits & Savings',
    description: 'Join JUV Membership for exclusive pricing, priority booking, and special perks. Choose from Glow, Radiance, or Luminous tiers to fit your aesthetic goals.',
    keywords: ['medspa membership', 'aesthetic membership', 'beauty membership', 'treatment packages', 'exclusive pricing'],
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Product',
      'name': 'JUV Membership Plans',
      'description': 'Exclusive membership tiers with treatment discounts and benefits'
    }
  },
  '/locations': {
    title: 'JUV Medspa™ Locations - Find Your Nearest Clinic',
    description: 'Find a JUV Medspa™ location near you. Premium aesthetic treatments available at convenient locations with expert providers.',
    keywords: ['medspa locations', 'aesthetic clinic locations', 'botox near me', 'medspa near me'],
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      'name': 'JUV Medspa™',
      '@id': 'https://juvmedspa.com'
    }
  },
  '/about': {
    title: 'About JUV Medspa™ - Our Story & Mission',
    description: 'Learn about JUV Medspa™\'s mission to democratize aesthetic healthcare through innovation, expertise, and genuine care. Founded by Dr. Parth Patel and Jonathan Cao.',
    keywords: ['about juv', 'medspa story', 'aesthetic medicine mission', 'dr parth patel', 'jonathan cao'],
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      'mainEntity': {
        '@type': 'MedicalBusiness',
        'name': 'JUV Medspa™'
      }
    }
  },
  '/sitemap': {
    title: 'JUV Sitemap - Complete Navigation Map',
    description: 'Complete sitemap of all JUV pages organized by audience: Patients, Providers, Staff, and Platform utilities. Find all JUV features and pages in one place.',
    keywords: ['sitemap', 'navigation', 'juv pages', 'site map', 'website structure', 'page directory'],
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      'name': 'JUV Sitemap',
      'description': 'Complete navigation map of all JUV pages and features',
      'breadcrumb': {
        '@type': 'BreadcrumbList',
        'itemListElement': [
          {
            '@type': 'ListItem',
            'position': 1,
            'name': 'Home',
            'item': 'https://juvmedspa.com'
          },
          {
            '@type': 'ListItem',
            'position': 2,
            'name': 'Sitemap',
            'item': 'https://juvmedspa.com/sitemap'
          }
        ]
      }
    }
  }
};
